
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13400',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13400",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1003",
  "client-types": "static-1.505",
  "data-fetching-client": "static-1.10052",
  "foundations-components": "static-1.8641",
  "foundations-components-legacy": "static-1.1666",
  "foundations-theming": "static-1.4884",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.92",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8444",
  "hub-http-shared-msw-handlers": "static-1.10781",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11897",
  "I18n": "static-7.1691",
  "jasmine-runner": "static-1.6853",
  "marketplace-discovery-studio-lib": "static-1.794",
  "marketplace-storefront-base": "static-1.13463",
  "quartz": "static-1.7578",
  "react-dlb": "static-1.92",
  "react-rhumb": "static-1-fix-undefined-routespec-crash.10",
  "reactive-variable-buffer-atom": "static-1.3257",
  "reporting-testing-lib": "static-1.11070",
  "reselect": "static-3.15",
  "settings-ui-lib": "static-1.12934",
  "SharedI18nStrings": "static-1.186",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7756",
  "ui-addon-i18n": "static-1.11552",
  "ui-addon-react-router-dom": "static-1.9935",
  "unified-auth": "static-1.1114",
  "unified-auth-core-lib": "static-1.1396",
  "usage-tracker": "static-1.7719",
  "usage-tracker-core": "static-1.7569",
  "customer-data-property-utils": "static-1.8463",
  "hub-http": "static-1.6615",
  "integrations-lib": "static-1.17274",
  "marketplace-ui-common": "static-1.20937",
  "marketplace-ui-install": "static-1.923",
  "property-management-iframe": "static-1.14326",
  "quartz-config": "static-1.1356",
  "quartz-core": "static-1.6797",
  "quartz-routing": "static-1.1008",
  "quick-fetch": "static-1.4187",
  "react": "static-7.202",
  "rpc-client-utils": "static-1.5073",
  "ts-schema": "static-1.4356",
  "ui-universal-auth": "static-1.9600",
  "UIComponents": "static-3.8843",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3855",
  "quartz-webpack": "static-1.3802",
  "bend-plugin-quartz-routing": "static-1.656",
  "ai-components-ui-library": "static-1.9903",
  "codemirror": "static-5.105",
  "foundations-assets": "static-1.5292",
  "pulse": "static-1.1044",
  "react-codemirror": "static-1.11045",
  "ui-extensions-preview-lib": "static-1.795",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4910",
  "floating-ui": "static-1.66",
  "foundations-theming-specialty": "static-1.2600",
  "framer-motion": "static-1.82",
  "hs-story-utils": "static-1.9831",
  "react-aria": "static-1.75",
  "react-create-root-preference": "static-1.88",
  "react-select-plus": "static-1.116",
  "react-utils": "static-2.5619",
  "react-virtualized": "static-2.110",
  "StyleGuideUI": "static-3.512",
  "tanstack-table": "static-1.64",
  "trellis-assets": "static-1.2924",
  "ui-fonts": "static-1.1159",
  "ui-images": "static-2.1269",
  "bend-plugin-foundations-theming": "static-1.3367",
  "foundations-theming-base": "static-1.3869",
  "stylex": "static-1.45",
  "HeadJS": "static-2.811",
  "hs-test-utils-bend-plugin": "static-1.3555",
  "msw": "static-1.39",
  "msw-config": "static-1.16",
  "testing-library": "static-1.162",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4714",
  "ui-addon-video-player": "static-1.9057",
  "ai-rendering-library": "static-1.11281",
  "chirp-fetch": "static-1.2305",
  "connections-embed-lib": "static-1.1651",
  "copilot-toolkit": "static-1.12021",
  "feedback-loader": "static-1.29954",
  "laboratory-lib": "static-3.7556",
  "marketplace-embed": "static-1.23082",
  "marketplace-ui-details": "static-1.10832",
  "marketplace-ui-reviews": "static-1.20892",
  "marketplace-ui-tracking": "static-1.15107",
  "sanitize-text": "static-1.8563",
  "usage-tracker-multi": "static-1.6133",
  "usage-tracker-session-replay": "static-1.5405",
  "wootric-nps": "static-1.7258",
  "quartz-head": "static-1.1243",
  "web-vitals": "static-1.18",
  "apollo-link-hub-http": "static-2.5018",
  "immer": "static-1.104",
  "immerable": "static-1.4548",
  "highcharts": "static-8.114",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2770",
  "reporting-data": "static-1.69137",
  "cssUtils": "static-1.1026",
  "flux-actions": "static-1.378",
  "react-colorpicker": "static-2.10617",
  "react-dnd-compat": "static-1.5017",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10776",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7709",
  "icons": "static-2.699",
  "marketplace-ui-apps-core": "static-1.19469",
  "storybook-react": "static-1.43",
  "trellis-story-utils": "static-1.4912",
  "foundations-components-test-utils": "static-1.6124",
  "quartz-i18n": "static-1.1253",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.644",
  "ads-unified-auth-lib": "static-1.1723",
  "custom-vendor-connection-lib": "static-1.164",
  "google-sheets-integration-lib": "static-1.1207",
  "microsoft-drive-auth-lib": "static-1.370",
  "surveymonkey-integration-lib": "static-1.725",
  "slack-ui-library": "static-1.10803",
  "fsm": "static-1.4159",
  "customer-data-objects": "static-1.8098",
  "property-translator": "static-1.5786",
  "hs-locale-management": "static-1.357",
  "frontend-preferences-client": "static-1.8324",
  "hs-promise-utils": "static-1.5995",
  "hubspot-apollo-client": "static-1.5280",
  "integrations-error-boundary-lib": "static-1.14689",
  "integrations-tracking-lib": "static-1.6016",
  "native-integrations-shared-strings": "static-1.8168",
  "sanitize": "static-1.4877",
  "superstore": "static-1.5164",
  "ui-shepherd-react": "static-3.10679",
  "ai-settings-ui-library": "static-1.8477",
  "hub-http-janus": "static-1.896",
  "hubspotter-http": "static-1.4922",
  "immutable-less": "static-1.5055",
  "marketplace-ui-client-types": "static-1.18344",
  "nav-meta": "static-1.30669",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18502",
  "ui-product-approvals-common": "static-1.1390",
  "ai-studio-lib": "static-1.12608",
  "hubspot-prosemirror": "static-1.19158",
  "integrations-reconnect-lib": "static-1.624",
  "ui-addon-iframeable": "static-1.9484",
  "ui-addon-integrations-directory-panel": "static-2.8387",
  "ui-product-approvals": "static-1.29495",
  "ui-tool-access": "static-1.10561",
  "inbound-db-properties-service-client": "static-1.4104",
  "property-management-common": "static-1.6614",
  "opentelemetry-fe-types": "static-1.190",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.593",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1.565",
  "quartz-auth": "static-1.1253",
  "quartz-test": "static-1.1253",
  "quartz-tracking": "static-1.957",
  "trellis-components": "static-1.2943",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.483",
  "HubStyle": "static-2.12204",
  "bender-build-tools": "static-1.3472",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23443",
  "ContentUtils": "static-1.69322",
  "customer-data-objects-ui-components": "static-1.13435",
  "sassPrefix": "static-1.295",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.547",
  "batch-promise": "static-1.1951",
  "event-emitter": "static-1.1365",
  "fast-json-patch": "static-1.73",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5842",
  "magpie-types": "static-1.5302",
  "stylex-utils": "static-1.158",
  "trellis-theming": "static-1.1386",
  "avatar-components": "static-1.2889",
  "breeze-engine-core": "static-1.1260",
  "breeze-onboarding-components": "static-1.929",
  "customer-data-filters-ui": "static-1.41187",
  "customer-data-reference-ui-components": "static-1.13573",
  "data-integrations-breeze": "static-1.149",
  "embedded-academy-lib": "static-1.15802",
  "ExportDialog": "static-6.10781",
  "global-styles-ai-lib": "static-1.330",
  "highlight.js": "static-1.89",
  "marketplace-embed-ba": "static-1.785",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42251",
  "reporting-snowflake": "static-1.57753",
  "reporting-ui-components": "static-2.66406",
  "reporting-visualizations": "static-1.61211",
  "trial-components-library": "static-1.14278",
  "ui-addon-teams": "static-1.21968",
  "upgrade-components-lib": "static-1.641",
  "navigation-components": "static-1.19032",
  "breeze-engine-lib": "static-1.1982",
  "simple-logging-lib": "static-1.3458",
  "nudge-client-utils": "static-1.3296",
  "fail-safe": "static-1.358",
  "app-governance-lib": "static-1.2564",
  "developer-experience-shared-components": "static-1.10943",
  "purchase-motions-components": "static-1.6549",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10587",
  "usage-tracker-anonymous": "static-1.6136",
  "usage-tracker-public": "static-1.7530",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3736",
  "persist-promise": "static-1.4108",
  "reference-resolvers": "static-1.8586",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4322",
  "hubspot-apollo-cache": "static-1.739",
  "universal-page-editor-lib": "static-1.3416",
  "final-form": "static-1.81",
  "redux-toolkit": "static-1.81",
  "simple-data-table": "static-1.3699",
  "merchandise-lib": "static-1.282",
  "onboarding-scopes": "static-1.6857",
  "ui-addon-draggable": "static-3.5151",
  "content-assistance-lib": "static-1.8329",
  "content-media-capture": "static-1.5650",
  "customer-data-ui-utilities": "static-1.10237",
  "emoji-mart": "static-3.6",
  "file-manager-components": "static-1.24716",
  "growth-payments-core": "static-1.26371",
  "knowledge-content-types": "static-1.8699",
  "PatternValidationJS": "static-1.3293",
  "payment-link-components": "static-1.24304",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20450",
  "ui-addon-emoji-picker": "static-1.10273",
  "ui-business-units-lib": "static-1.9501",
  "video-components-external": "static-1.12317",
  "video-data-lib": "static-1.35975",
  "navigation-messaging": "static-1.8359",
  "collaboration-sidebar": "static-1.58919",
  "trellis-ext-dnd": "static-1.434",
  "crm-component-utils": "static-1.40030",
  "crm-properties-common-lib": "static-1.6294",
  "customer-data-properties": "static-1.52854",
  "external-options-client-types": "static-1.4404",
  "framework-data-schema-resolvers": "static-1.7301",
  "property-value-citations": "static-1.3468",
  "reference-resolvers-lite": "static-1.8510",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.106",
  "hubspotter-http-shared-msw-handlers": "static-1.10779",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "tanstack-virtual": "static-1.41",
  "cms-field-types": "static-1.5218",
  "content-icons-ui": "static-1.2417",
  "atom": "static-1.5483",
  "idb-keyval": "static-1.54",
  "reactive-lib": "static-1.1128",
  "breeze-artifacts-sdk": "static-1.648",
  "getting-started-shared-tasks": "static-1.19437",
  "onboarding-journeys-lib": "static-1.1119",
  "conversations-skeleton-state": "static-1.7602",
  "crm-message-bus": "static-1.43958",
  "customer-data-filters-ui-msw-helpers": "static-1.23622",
  "events-data-lib": "static-1.653",
  "FormUrlGenerator": "static-2.5118",
  "framework-builder-read-service-client": "static-1.4285",
  "hs-resources": "static-1.600",
  "multi-account-reference-resolvers": "static-1.1408",
  "onboarding-tours": "static-1.17287",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14642",
  "segments-client-types": "static-1.11908",
  "academy-common-lib": "static-1.15262",
  "dashboard-lib": "static-1.83114",
  "hubspot-prosemirror-plugins": "static-1.19150",
  "share-with-third-party-component-lib": "static-1.9116",
  "ui-asset-management-lib": "static-1.11508",
  "user-context": "static-1.5475",
  "reporting-plugins": "static-1.10891",
  "reporting-reports": "static-1.68813",
  "hubs-service-types": "static-1.1669",
  "purchase-motions-api": "static-1.6552",
  "salesImages": "static-1.665",
  "signup-constants": "static-1.19809",
  "nest": "static-1.641",
  "breeze-engine-chat-components": "static-1.960",
  "ably": "static-2.2",
  "nudge-custom-function-registry": "static-1.3053",
  "nudge-renderer-utils": "static-1.3372",
  "whisper-core-api": "static-1.7511",
  "bend-plugin-fail-safe": "static-1.309",
  "framework-listing-lib": "static-2.29683",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31625",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4597",
  "signup-ui-url-generator": "static-2.8465",
  "onboarding-tours-client": "static-1.5502",
  "one-click-checkout": "static-1.629",
  "platform-infra-nav-components": "static-1.7960",
  "subscription-experience-data-types": "static-1.15353",
  "crm-record-cards-service-types": "static-1.3833",
  "location-customization-utils-lib": "static-1.10293",
  "redux-thunk": "static-2.83",
  "react-flip-move": "static-1.81",
  "ui-coaching-tips": "static-1.29484",
  "content-media-composition-data-lib": "static-1.13454",
  "fix-webm-duration": "static-1.33",
  "notification-sounds": "static-1.4831",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3878",
  "seat-types-lib": "static-1.919",
  "ui-addon-opt": "static-4.8778",
  "commerce-tours-lib": "static-1.6763",
  "growth-onboarding-reliability": "static-1.5488",
  "sales-checkout-service-client": "static-1.3935",
  "data-token-picker": "static-1.17027",
  "FileManagerLib": "static-1.40356",
  "content-media-compositions": "static-2.17461",
  "media-bridge-lib": "static-1.19541",
  "chatspot-widget-iframe": "static-1.23434",
  "collaboration-sidebar-common": "static-1.3716",
  "marketing-platform-lib": "static-1.7297",
  "dnd-kit": "static-1.19",
  "card-properties-lib": "static-1.45190",
  "commerce-subscription-lib": "static-1.37971",
  "crm-actions": "static-1.6756",
  "crm-cards-sdk": "static-1.44836",
  "customer-data-properties-shared-msw-handlers": "static-1.10108",
  "customer-data-tracking": "static-1.7278",
  "calling-global-api": "static-1.65939",
  "calling-internal-common": "static-1.31727",
  "calling-lifecycle-internal": "static-1.67321",
  "calling-lifecycle-messages": "static-1.59614",
  "commerce-products-lib": "static-1.10740",
  "conditional-properties-service-client": "static-1.4079",
  "crm-index-visualization-core": "static-1.4665",
  "crm-links": "static-1.6708",
  "crm-pipelines-api-client-types": "static-1.4409",
  "formula-editor": "static-1.14919",
  "google-libphonenumber": "static-1.48",
  "inbounddb-objects-service-types": "static-1.4486",
  "meetings-icalendar-utils-lib": "static-1.1042",
  "multi-currency-client-types": "static-1.3973",
  "object-builder-ui-client": "static-1.49888",
  "pipeline-validation-client-types": "static-1.4246",
  "smart-data-capture-core": "static-1.328",
  "smart-property-lib": "static-1.8501",
  "tiered-pricing": "static-1.2120",
  "topics-actions-lib": "static-1.581",
  "ui-addon-form-validation": "static-1.11337",
  "zustand": "static-1.87",
  "fdsr-migration-layer": "static-1.420",
  "framework-data-schema-quick-fetch": "static-1.7206",
  "restore-request-side-panel-lib": "static-1.1884",
  "growth-data-modal": "static-1.6032",
  "growth-onboarding-confetti": "static-1.3469",
  "growth-onboarding-next-action-utils": "static-1.2865",
  "onboarding-tours-utils": "static-1.1354",
  "ui-shepherd-tracker": "static-1.8060",
  "crm-index-associations-lib": "static-1.6853",
  "academy-service-client": "static-1.4099",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40215",
  "SafeStorage": "static-1.4800",
  "video-embed": "static-1.36809",
  "redux-actions": "static-3.73",
  "EmailSignatureEditor": "static-1.25136",
  "viral-links-lib": "static-1.7484",
  "nested-table": "static-1.642",
  "timezone-utils": "static-2.5636",
  "getting-started-shared-tasks-store": "static-1.18555",
  "campaign-roi-lib": "static-1.10621",
  "campaigns-utils-lib": "static-1.3638",
  "ui-addon-calendars": "static-2.5764",
  "customer-data-views-management": "static-1.26203",
  "framework-data-table": "static-2.12724",
  "nudge-custom-ui-functions": "static-1.1640",
  "switchboard-lib": "static-1.628",
  "access-check-ui-lib": "static-1.1768",
  "app-users-service-client": "static-1.6025",
  "app-users-service-types": "static-1.5433",
  "mini-checkout-client": "static-1.27724",
  "onboarding-utils": "static-1.5775",
  "permissions-shared-i18n-strings-fe": "static-1.2142",
  "ui-coaching-tips-shared-config": "static-1.29469",
  "checkout-sdk": "static-3.24567",
  "payment-method-components": "static-1.7252",
  "touchless-buying-components": "static-1.6435",
  "upgrade-catalog-service-types": "static-1.3832",
  "edison-service-client-types": "static-1.800",
  "growth-onboarding-feedback-components": "static-1.6989",
  "audio-components": "static-1.6477",
  "FileManagerImages": "static-1.37867",
  "video-components": "static-1.14319",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.93057",
  "customer-data-sidebar": "static-2.46903",
  "enrichment-lib": "static-1.751",
  "ui-addon-draggable-compat": "static-2.4668",
  "universal-record-utils-lib": "static-1.2212",
  "commerce-billing-lib": "static-1.20412",
  "commerce-shared-components-lib": "static-1.19453",
  "commerce-tools-ui-lib": "static-1.11207",
  "crm-fe-perf": "static-1.23302",
  "calling-error-reporting": "static-1.31734",
  "shared-worker-versioning": "static-1.11445",
  "calling-usage-tracker": "static-1.6941",
  "voice-sms-access-library": "static-1.2290",
  "commerce-permissions": "static-1.1183",
  "products-iframe-lib": "static-1.8757",
  "products-ui-components-shared-msw-handlers": "static-1.11163",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10864",
  "sales-views-client-types": "static-1.4664",
  "bark-lib": "static-1.16936",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.790",
  "policy-lib": "static-1.7211",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10927",
  "onboarding-data-sync-lib": "static-1.2717",
  "growth-onboarding-next-action-components": "static-1.2893",
  "user-context-client": "static-1.4914",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "urlinator": "static-1.4921",
  "outpost": "static-1.4540",
  "draft-convert": "static-2.82",
  "draft-extend": "static-3.86",
  "draft-js": "static-5.88",
  "draft-plugins": "static-2.22253",
  "sales-email-signature-service-client": "static-1.4253",
  "ts-utils-lib": "static-1.554",
  "copilot-messaging": "static-1.2271",
  "crm-export-dialog": "static-1.6686",
  "crm-index-ui-shimmer": "static-1.2863",
  "crm-view-components": "static-1.1383",
  "react-beautiful-dnd": "static-1.73",
  "customer-data-associations": "static-1.7736",
  "tasks-actions-lib": "static-1.321",
  "InboxConnectUtils": "static-4.15725",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.47023",
  "hub-http-rxjs": "static-1.864",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4397",
  "company-details-components": "static-1.6612",
  "react-performance-metrics-lib": "static-1.960",
  "pricing-pages-ui-components": "static-1.16292",
  "quote-checkout-service-types": "static-1.3863",
  "social-insights-client-types": "static-1.22811",
  "crm_universal": "static-1.22620",
  "customer-data-email": "static-1.18589",
  "card-payment-highlight-lib": "static-1.38177",
  "commerce-contract-lib": "static-1.13612",
  "invoices-highlight-card-lib": "static-1.56021",
  "orders-highlight-card-lib": "static-1.22373",
  "products-highlight-card-lib": "static-1.19023",
  "quotes-highlight-card-lib": "static-1.72967",
  "crm-source-interpretation-lib": "static-1.5735",
  "data-agent-test-utils": "static-1.334",
  "data-agent-utils": "static-1.803",
  "enrichment-settings-lib": "static-1.96",
  "crm-object-search-query-utilities": "static-1.10351",
  "utility-belt": "static-1.2940",
  "payments-enrollment-embed-lib": "static-1.24075",
  "stripe-embedded-components": "static-1.8134",
  "customer-data-rte": "static-1.33788",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6426",
  "payments-post-enroll-local-storage-lib": "static-1.5509",
  "qrcode-generator": "static-1.79",
  "quotes-client-types": "static-1.39057",
  "calling-orchestration-schema": "static-1.37067",
  "react-reducer-toolkit": "static-1.16541",
  "meetings-connect-utils-lib": "static-1.8021",
  "hub-http-contrib": "static-1.3432",
  "ui-addon-sales-email": "static-1.5609",
  "access-control-lib": "static-1.10834",
  "EmailComponents": "static-1.55723",
  "EmailData": "static-1.54401",
  "messaging-base-table-lib": "static-1.682",
  "redux-less": "static-2.9867",
  "company-details-service-types": "static-1.4349",
  "segments-query-core": "static-1.1834",
  "pricing-pages-api": "static-1.16157",
  "sequences-lib": "static-1.8667",
  "ui-gdpr-components": "static-1.10648",
  "products-ui-components": "static-1.41258",
  "reporting-enablement": "static-1.24020",
  "accounting-integrations-ui-components": "static-1.7692",
  "invoices-ui-lib": "static-1.56037",
  "commerce-products-api": "static-1.2819",
  "invoices-iframe-lib": "static-1.58095",
  "quotes-modal-lib": "static-1.103645",
  "quotes-ui-lib": "static-1.81688",
  "stripe-connect-js": "static-1.81",
  "draft-content-plugins": "static-1.29044",
  "ContentComponents": "static-2.72278",
  "ContentData": "static-1.69397",
  "marketing-email-service-types": "static-1.2172",
  "messaging-editing-lib": "static-1.47339",
  "messaging-usage-based-billing-components-lib": "static-1.2201",
  "automation-ui-source-apps": "static-1.19856",
  "automation-ui-types": "static-1.20774",
  "messaging-types-lib": "static-1.47076",
  "onboarding-settings-client": "static-1.4914",
  "sequences-client-types-lib": "static-1.8524",
  "commerce-tax-lib": "static-1.944",
  "price-books-api": "static-1.1905",
  "price-books-components": "static-1.1963",
  "property-description-translator": "static-1.4227",
  "ramp-editor": "static-1.1054",
  "data-quality-ui-library": "static-1.14140",
  "report-customization-components": "static-1.14083",
  "reporting-filters": "static-1.1173",
  "reporting-insights-lib": "static-1.2776",
  "commerce-analytics-service-client": "static-1.3923",
  "totals-ui-components": "static-1.24453",
  "SalesContentIndexUI": "static-3.9686",
  "advanced-menus-core": "static-1.15711",
  "advanced-menus-lib": "static-1.12512",
  "automation-ui-ubb": "static-1.6690",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7744",
  "data-token-views": "static-1.17008",
  "forms-utils-lib": "static-1.13231",
  "payments-embed-points-lib": "static-1.13739",
  "react-tinymce": "static-1.56150",
  "simple-menus-core": "static-1.15710",
  "simple-menus-lib": "static-1.17227",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55276",
  "tinymce-data": "static-1.41361",
  "tinymce-plugins": "static-1.58390",
  "tinymce-themes": "static-1.57246",
  "ui-brand-identity-lib": "static-1.16767",
  "ui-memberships-settings-lib": "static-1.35042",
  "videoconference-integration-components": "static-1.7428",
  "automation-applications-service-types": "static-1.3694",
  "automation-platform-service-types": "static-1.2705",
  "ContentEditorUI": "static-2.78108",
  "content-whatsapp-service-types": "static-1.631",
  "short-messages-app-service-client": "static-1.4328",
  "web-interactives-components": "static-1.14387",
  "web-interactives-data": "static-1.14388",
  "messaging-shared-utils-lib": "static-1.1650",
  "messaging-user-info-utils-lib": "static-1.1820",
  "email-portal-health-service-types": "static-1.1388",
  "line-items-api": "static-1.1226",
  "merge-modal-lib": "static-1.12896",
  "commerce-totals-service-types": "static-1.4095",
  "FireAlarmUi": "static-1.4793",
  "sales-templates-service-types-lib": "static-1.4448",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22710",
  "automation-ui-usage-tracking": "static-1.22173",
  "data-studio-ubb": "static-1.3686",
  "interframe": "static-3.5147",
  "layout-dnd-components": "static-1.13111",
  "layout-dnd-utils": "static-1.12086",
  "NamespacedHubStyle": "static-2.9321",
  "campaigns-lib": "static-1.27782",
  "content-management-data-lib": "static-1.6117",
  "copilot-plugins": "static-1.11993",
  "cta-picker": "static-1.37165",
  "customer-agent-discovery-components-lib": "static-1.4145",
  "editor-components": "static-1.13789",
  "editor-iframe-lib": "static-1.8916",
  "error-messaging-js": "static-1.5554",
  "FormsCommonComponents": "static-1.86727",
  "layout-data-lib": "static-1.10411",
  "pictos": "static-7.194",
  "react-transition-group": "static-2.76",
  "redux-request-state": "static-1.11044",
  "SharedLegalStrings": "static-1.2133",
  "smart-content-core": "static-1.43341",
  "smart-content-lib": "static-1.43994",
  "social-composer-lib": "static-1.60472",
  "structured-content-lib": "static-1.26079",
  "theme-previewer-lib": "static-1.54056",
  "tinymce-copilot": "static-1.17344",
  "xray-recommendation-lib": "static-1.8375",
  "automation-ui-routing": "static-1.22131",
  "sql-reporting-client-types": "static-1.5966",
  "attribution-lib": "static-1.42909",
  "voice-agents-components": "static-1.3961",
  "forms-ai-lib": "static-1.4890",
  "codemirror-dlb": "static-1.59667",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6851",
  "calling-orchestration-shared-library": "static-1.36842"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13400",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1003",
  "client-types": "/client-types/static-1.505",
  "data-fetching-client": "/data-fetching-client/static-1.10052",
  "foundations-components": "/foundations-components/static-1.8641",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1666",
  "foundations-theming": "/foundations-theming/static-1.4884",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.92",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8444",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10781",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11897",
  "I18n": "/I18n/static-7.1691",
  "jasmine-runner": "/jasmine-runner/static-1.6853",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.794",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13463",
  "quartz": "/quartz/static-1.7578",
  "react-dlb": "/react-dlb/static-1.92",
  "react-rhumb": "/react-rhumb/static-1-fix-undefined-routespec-crash.10",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3257",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11070",
  "reselect": "/reselect/static-3.15",
  "settings-ui-lib": "/settings-ui-lib/static-1.12934",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7756",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11552",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9935",
  "unified-auth": "/unified-auth/static-1.1114",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1396",
  "usage-tracker": "/usage-tracker/static-1.7719",
  "usage-tracker-core": "/usage-tracker-core/static-1.7569",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8463",
  "hub-http": "/hub-http/static-1.6615",
  "integrations-lib": "/integrations-lib/static-1.17274",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20937",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.923",
  "property-management-iframe": "/property-management-iframe/static-1.14326",
  "quartz-config": "/quartz-config/static-1.1356",
  "quartz-core": "/quartz-core/static-1.6797",
  "quartz-routing": "/quartz-routing/static-1.1008",
  "quick-fetch": "/quick-fetch/static-1.4187",
  "react": "/react/static-7.202",
  "rpc-client-utils": "/rpc-client-utils/static-1.5073",
  "ts-schema": "/ts-schema/static-1.4356",
  "ui-universal-auth": "/ui-universal-auth/static-1.9600",
  "UIComponents": "/UIComponents/static-3.8843",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3855",
  "quartz-webpack": "/quartz-webpack/static-1.3802",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.656",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9903",
  "codemirror": "/codemirror/static-5.105",
  "foundations-assets": "/foundations-assets/static-1.5292",
  "pulse": "/pulse/static-1.1044",
  "react-codemirror": "/react-codemirror/static-1.11045",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.795",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4910",
  "floating-ui": "/floating-ui/static-1.66",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2600",
  "framer-motion": "/framer-motion/static-1.82",
  "hs-story-utils": "/hs-story-utils/static-1.9831",
  "react-aria": "/react-aria/static-1.75",
  "react-create-root-preference": "/react-create-root-preference/static-1.88",
  "react-select-plus": "/react-select-plus/static-1.116",
  "react-utils": "/react-utils/static-2.5619",
  "react-virtualized": "/react-virtualized/static-2.110",
  "StyleGuideUI": "/StyleGuideUI/static-3.512",
  "tanstack-table": "/tanstack-table/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.2924",
  "ui-fonts": "/ui-fonts/static-1.1159",
  "ui-images": "/ui-images/static-2.1269",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3367",
  "foundations-theming-base": "/foundations-theming-base/static-1.3869",
  "stylex": "/stylex/static-1.45",
  "HeadJS": "/HeadJS/static-2.811",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3555",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.16",
  "testing-library": "/testing-library/static-1.162",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4714",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ai-rendering-library": "/ai-rendering-library/static-1.11281",
  "chirp-fetch": "/chirp-fetch/static-1.2305",
  "connections-embed-lib": "/connections-embed-lib/static-1.1651",
  "copilot-toolkit": "/copilot-toolkit/static-1.12021",
  "feedback-loader": "/feedback-loader/static-1.29954",
  "laboratory-lib": "/laboratory-lib/static-3.7556",
  "marketplace-embed": "/marketplace-embed/static-1.23082",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10832",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20892",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15107",
  "sanitize-text": "/sanitize-text/static-1.8563",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6133",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5405",
  "wootric-nps": "/wootric-nps/static-1.7258",
  "quartz-head": "/quartz-head/static-1.1243",
  "web-vitals": "/web-vitals/static-1.18",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5018",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4548",
  "highcharts": "/highcharts/static-8.114",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2770",
  "reporting-data": "/reporting-data/static-1.69137",
  "cssUtils": "/cssUtils/static-1.1026",
  "flux-actions": "/flux-actions/static-1.378",
  "react-colorpicker": "/react-colorpicker/static-2.10617",
  "react-dnd-compat": "/react-dnd-compat/static-1.5017",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10776",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7709",
  "icons": "/icons/static-2.699",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19469",
  "storybook-react": "/storybook-react/static-1.43",
  "trellis-story-utils": "/trellis-story-utils/static-1.4912",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6124",
  "quartz-i18n": "/quartz-i18n/static-1.1253",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.644",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1723",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.164",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1207",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.370",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.725",
  "slack-ui-library": "/slack-ui-library/static-1.10803",
  "fsm": "/fsm/static-1.4159",
  "customer-data-objects": "/customer-data-objects/static-1.8098",
  "property-translator": "/property-translator/static-1.5786",
  "hs-locale-management": "/hs-locale-management/static-1.357",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8324",
  "hs-promise-utils": "/hs-promise-utils/static-1.5995",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5280",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14689",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6016",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8168",
  "sanitize": "/sanitize/static-1.4877",
  "superstore": "/superstore/static-1.5164",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10679",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8477",
  "hub-http-janus": "/hub-http-janus/static-1.896",
  "hubspotter-http": "/hubspotter-http/static-1.4922",
  "immutable-less": "/immutable-less/static-1.5055",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18344",
  "nav-meta": "/nav-meta/static-1.30669",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18502",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1390",
  "ai-studio-lib": "/ai-studio-lib/static-1.12608",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19158",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.624",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9484",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8387",
  "ui-product-approvals": "/ui-product-approvals/static-1.29495",
  "ui-tool-access": "/ui-tool-access/static-1.10561",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4104",
  "property-management-common": "/property-management-common/static-1.6614",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.190",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.593",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.565",
  "quartz-auth": "/quartz-auth/static-1.1253",
  "quartz-test": "/quartz-test/static-1.1253",
  "quartz-tracking": "/quartz-tracking/static-1.957",
  "trellis-components": "/trellis-components/static-1.2943",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.483",
  "HubStyle": "/HubStyle/static-2.12204",
  "bender-build-tools": "/bender-build-tools/static-1.3472",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23443",
  "ContentUtils": "/ContentUtils/static-1.69322",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13435",
  "sassPrefix": "/sassPrefix/static-1.295",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.547",
  "batch-promise": "/batch-promise/static-1.1951",
  "event-emitter": "/event-emitter/static-1.1365",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5842",
  "magpie-types": "/magpie-types/static-1.5302",
  "stylex-utils": "/stylex-utils/static-1.158",
  "trellis-theming": "/trellis-theming/static-1.1386",
  "avatar-components": "/avatar-components/static-1.2889",
  "breeze-engine-core": "/breeze-engine-core/static-1.1260",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.929",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41187",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13573",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.149",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15802",
  "ExportDialog": "/ExportDialog/static-6.10781",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.330",
  "highlight.js": "/highlight.js/static-1.89",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.785",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42251",
  "reporting-snowflake": "/reporting-snowflake/static-1.57753",
  "reporting-ui-components": "/reporting-ui-components/static-2.66406",
  "reporting-visualizations": "/reporting-visualizations/static-1.61211",
  "trial-components-library": "/trial-components-library/static-1.14278",
  "ui-addon-teams": "/ui-addon-teams/static-1.21968",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.641",
  "navigation-components": "/navigation-components/static-1.19032",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1982",
  "simple-logging-lib": "/simple-logging-lib/static-1.3458",
  "nudge-client-utils": "/nudge-client-utils/static-1.3296",
  "fail-safe": "/fail-safe/static-1.358",
  "app-governance-lib": "/app-governance-lib/static-1.2564",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10943",
  "purchase-motions-components": "/purchase-motions-components/static-1.6549",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10587",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6136",
  "usage-tracker-public": "/usage-tracker-public/static-1.7530",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3736",
  "persist-promise": "/persist-promise/static-1.4108",
  "reference-resolvers": "/reference-resolvers/static-1.8586",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4322",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.739",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3416",
  "final-form": "/final-form/static-1.81",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "simple-data-table": "/simple-data-table/static-1.3699",
  "merchandise-lib": "/merchandise-lib/static-1.282",
  "onboarding-scopes": "/onboarding-scopes/static-1.6857",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5151",
  "content-assistance-lib": "/content-assistance-lib/static-1.8329",
  "content-media-capture": "/content-media-capture/static-1.5650",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10237",
  "emoji-mart": "/emoji-mart/static-3.6",
  "file-manager-components": "/file-manager-components/static-1.24716",
  "growth-payments-core": "/growth-payments-core/static-1.26371",
  "knowledge-content-types": "/knowledge-content-types/static-1.8699",
  "PatternValidationJS": "/PatternValidationJS/static-1.3293",
  "payment-link-components": "/payment-link-components/static-1.24304",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20450",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10273",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9501",
  "video-components-external": "/video-components-external/static-1.12317",
  "video-data-lib": "/video-data-lib/static-1.35975",
  "navigation-messaging": "/navigation-messaging/static-1.8359",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58919",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.434",
  "crm-component-utils": "/crm-component-utils/static-1.40030",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6294",
  "customer-data-properties": "/customer-data-properties/static-1.52854",
  "external-options-client-types": "/external-options-client-types/static-1.4404",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7301",
  "property-value-citations": "/property-value-citations/static-1.3468",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8510",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.106",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10779",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "cms-field-types": "/cms-field-types/static-1.5218",
  "content-icons-ui": "/content-icons-ui/static-1.2417",
  "atom": "/atom/static-1.5483",
  "idb-keyval": "/idb-keyval/static-1.54",
  "reactive-lib": "/reactive-lib/static-1.1128",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.648",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19437",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1119",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-message-bus": "/crm-message-bus/static-1.43958",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23622",
  "events-data-lib": "/events-data-lib/static-1.653",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5118",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4285",
  "hs-resources": "/hs-resources/static-1.600",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1408",
  "onboarding-tours": "/onboarding-tours/static-1.17287",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14642",
  "segments-client-types": "/segments-client-types/static-1.11908",
  "academy-common-lib": "/academy-common-lib/static-1.15262",
  "dashboard-lib": "/dashboard-lib/static-1.83114",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19150",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9116",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11508",
  "user-context": "/user-context/static-1.5475",
  "reporting-plugins": "/reporting-plugins/static-1.10891",
  "reporting-reports": "/reporting-reports/static-1.68813",
  "hubs-service-types": "/hubs-service-types/static-1.1669",
  "purchase-motions-api": "/purchase-motions-api/static-1.6552",
  "salesImages": "/salesImages/static-1.665",
  "signup-constants": "/signup-constants/static-1.19809",
  "nest": "/nest/static-1.641",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.960",
  "ably": "/ably/static-2.2",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3053",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3372",
  "whisper-core-api": "/whisper-core-api/static-1.7511",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.309",
  "framework-listing-lib": "/framework-listing-lib/static-2.29683",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31625",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8465",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5502",
  "one-click-checkout": "/one-click-checkout/static-1.629",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7960",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15353",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3833",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10293",
  "redux-thunk": "/redux-thunk/static-2.83",
  "react-flip-move": "/react-flip-move/static-1.81",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29484",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13454",
  "fix-webm-duration": "/fix-webm-duration/static-1.33",
  "notification-sounds": "/notification-sounds/static-1.4831",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3878",
  "seat-types-lib": "/seat-types-lib/static-1.919",
  "ui-addon-opt": "/ui-addon-opt/static-4.8778",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6763",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5488",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3935",
  "data-token-picker": "/data-token-picker/static-1.17027",
  "FileManagerLib": "/FileManagerLib/static-1.40356",
  "content-media-compositions": "/content-media-compositions/static-2.17461",
  "media-bridge-lib": "/media-bridge-lib/static-1.19541",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23434",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3716",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7297",
  "dnd-kit": "/dnd-kit/static-1.19",
  "card-properties-lib": "/card-properties-lib/static-1.45190",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37971",
  "crm-actions": "/crm-actions/static-1.6756",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44836",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10108",
  "customer-data-tracking": "/customer-data-tracking/static-1.7278",
  "calling-global-api": "/calling-global-api/static-1.65939",
  "calling-internal-common": "/calling-internal-common/static-1.31727",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67321",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59614",
  "commerce-products-lib": "/commerce-products-lib/static-1.10740",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4079",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4665",
  "crm-links": "/crm-links/static-1.6708",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4409",
  "formula-editor": "/formula-editor/static-1.14919",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4486",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1042",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3973",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49888",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4246",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.328",
  "smart-property-lib": "/smart-property-lib/static-1.8501",
  "tiered-pricing": "/tiered-pricing/static-1.2120",
  "topics-actions-lib": "/topics-actions-lib/static-1.581",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11337",
  "zustand": "/zustand/static-1.87",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.420",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7206",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1884",
  "growth-data-modal": "/growth-data-modal/static-1.6032",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3469",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2865",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1354",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8060",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6853",
  "academy-service-client": "/academy-service-client/static-1.4099",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40215",
  "SafeStorage": "/SafeStorage/static-1.4800",
  "video-embed": "/video-embed/static-1.36809",
  "redux-actions": "/redux-actions/static-3.73",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25136",
  "viral-links-lib": "/viral-links-lib/static-1.7484",
  "nested-table": "/nested-table/static-1.642",
  "timezone-utils": "/timezone-utils/static-2.5636",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18555",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10621",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3638",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5764",
  "customer-data-views-management": "/customer-data-views-management/static-1.26203",
  "framework-data-table": "/framework-data-table/static-2.12724",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1640",
  "switchboard-lib": "/switchboard-lib/static-1.628",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1768",
  "app-users-service-client": "/app-users-service-client/static-1.6025",
  "app-users-service-types": "/app-users-service-types/static-1.5433",
  "mini-checkout-client": "/mini-checkout-client/static-1.27724",
  "onboarding-utils": "/onboarding-utils/static-1.5775",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2142",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29469",
  "checkout-sdk": "/checkout-sdk/static-3.24567",
  "payment-method-components": "/payment-method-components/static-1.7252",
  "touchless-buying-components": "/touchless-buying-components/static-1.6435",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3832",
  "edison-service-client-types": "/edison-service-client-types/static-1.800",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6989",
  "audio-components": "/audio-components/static-1.6477",
  "FileManagerImages": "/FileManagerImages/static-1.37867",
  "video-components": "/video-components/static-1.14319",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.93057",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46903",
  "enrichment-lib": "/enrichment-lib/static-1.751",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4668",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2212",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20412",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19453",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11207",
  "crm-fe-perf": "/crm-fe-perf/static-1.23302",
  "calling-error-reporting": "/calling-error-reporting/static-1.31734",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11445",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6941",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2290",
  "commerce-permissions": "/commerce-permissions/static-1.1183",
  "products-iframe-lib": "/products-iframe-lib/static-1.8757",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11163",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10864",
  "sales-views-client-types": "/sales-views-client-types/static-1.4664",
  "bark-lib": "/bark-lib/static-1.16936",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.790",
  "policy-lib": "/policy-lib/static-1.7211",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10927",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2717",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2893",
  "user-context-client": "/user-context-client/static-1.4914",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "urlinator": "/urlinator/static-1.4921",
  "outpost": "/outpost/static-1.4540",
  "draft-convert": "/draft-convert/static-2.82",
  "draft-extend": "/draft-extend/static-3.86",
  "draft-js": "/draft-js/static-5.88",
  "draft-plugins": "/draft-plugins/static-2.22253",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4253",
  "ts-utils-lib": "/ts-utils-lib/static-1.554",
  "copilot-messaging": "/copilot-messaging/static-1.2271",
  "crm-export-dialog": "/crm-export-dialog/static-1.6686",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2863",
  "crm-view-components": "/crm-view-components/static-1.1383",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.73",
  "customer-data-associations": "/customer-data-associations/static-1.7736",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.321",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15725",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.47023",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.864",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4397",
  "company-details-components": "/company-details-components/static-1.6612",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.960",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16292",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3863",
  "social-insights-client-types": "/social-insights-client-types/static-1.22811",
  "crm_universal": "/crm_universal/static-1.22620",
  "customer-data-email": "/customer-data-email/static-1.18589",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38177",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13612",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.56021",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22373",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.19023",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72967",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5735",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.334",
  "data-agent-utils": "/data-agent-utils/static-1.803",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.96",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10351",
  "utility-belt": "/utility-belt/static-1.2940",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24075",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8134",
  "customer-data-rte": "/customer-data-rte/static-1.33788",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6426",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5509",
  "qrcode-generator": "/qrcode-generator/static-1.79",
  "quotes-client-types": "/quotes-client-types/static-1.39057",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37067",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16541",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8021",
  "hub-http-contrib": "/hub-http-contrib/static-1.3432",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5609",
  "access-control-lib": "/access-control-lib/static-1.10834",
  "EmailComponents": "/EmailComponents/static-1.55723",
  "EmailData": "/EmailData/static-1.54401",
  "messaging-base-table-lib": "/messaging-base-table-lib/static-1.682",
  "redux-less": "/redux-less/static-2.9867",
  "company-details-service-types": "/company-details-service-types/static-1.4349",
  "segments-query-core": "/segments-query-core/static-1.1834",
  "pricing-pages-api": "/pricing-pages-api/static-1.16157",
  "sequences-lib": "/sequences-lib/static-1.8667",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10648",
  "products-ui-components": "/products-ui-components/static-1.41258",
  "reporting-enablement": "/reporting-enablement/static-1.24020",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7692",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.56037",
  "commerce-products-api": "/commerce-products-api/static-1.2819",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.58095",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103645",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81688",
  "stripe-connect-js": "/stripe-connect-js/static-1.81",
  "draft-content-plugins": "/draft-content-plugins/static-1.29044",
  "ContentComponents": "/ContentComponents/static-2.72278",
  "ContentData": "/ContentData/static-1.69397",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2172",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47339",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2201",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19856",
  "automation-ui-types": "/automation-ui-types/static-1.20774",
  "messaging-types-lib": "/messaging-types-lib/static-1.47076",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4914",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8524",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.944",
  "price-books-api": "/price-books-api/static-1.1905",
  "price-books-components": "/price-books-components/static-1.1963",
  "property-description-translator": "/property-description-translator/static-1.4227",
  "ramp-editor": "/ramp-editor/static-1.1054",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.14140",
  "report-customization-components": "/report-customization-components/static-1.14083",
  "reporting-filters": "/reporting-filters/static-1.1173",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2776",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3923",
  "totals-ui-components": "/totals-ui-components/static-1.24453",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9686",
  "advanced-menus-core": "/advanced-menus-core/static-1.15711",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12512",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6690",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7744",
  "data-token-views": "/data-token-views/static-1.17008",
  "forms-utils-lib": "/forms-utils-lib/static-1.13231",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13739",
  "react-tinymce": "/react-tinymce/static-1.56150",
  "simple-menus-core": "/simple-menus-core/static-1.15710",
  "simple-menus-lib": "/simple-menus-lib/static-1.17227",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55276",
  "tinymce-data": "/tinymce-data/static-1.41361",
  "tinymce-plugins": "/tinymce-plugins/static-1.58390",
  "tinymce-themes": "/tinymce-themes/static-1.57246",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16767",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35042",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7428",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3694",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2705",
  "ContentEditorUI": "/ContentEditorUI/static-2.78108",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.631",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4328",
  "web-interactives-components": "/web-interactives-components/static-1.14387",
  "web-interactives-data": "/web-interactives-data/static-1.14388",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1650",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1820",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1388",
  "line-items-api": "/line-items-api/static-1.1226",
  "merge-modal-lib": "/merge-modal-lib/static-1.12896",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4095",
  "FireAlarmUi": "/FireAlarmUi/static-1.4793",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4448",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22710",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22173",
  "data-studio-ubb": "/data-studio-ubb/static-1.3686",
  "interframe": "/interframe/static-3.5147",
  "layout-dnd-components": "/layout-dnd-components/static-1.13111",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12086",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9321",
  "campaigns-lib": "/campaigns-lib/static-1.27782",
  "content-management-data-lib": "/content-management-data-lib/static-1.6117",
  "copilot-plugins": "/copilot-plugins/static-1.11993",
  "cta-picker": "/cta-picker/static-1.37165",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.4145",
  "editor-components": "/editor-components/static-1.13789",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8916",
  "error-messaging-js": "/error-messaging-js/static-1.5554",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86727",
  "layout-data-lib": "/layout-data-lib/static-1.10411",
  "pictos": "/pictos/static-7.194",
  "react-transition-group": "/react-transition-group/static-2.76",
  "redux-request-state": "/redux-request-state/static-1.11044",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2133",
  "smart-content-core": "/smart-content-core/static-1.43341",
  "smart-content-lib": "/smart-content-lib/static-1.43994",
  "social-composer-lib": "/social-composer-lib/static-1.60472",
  "structured-content-lib": "/structured-content-lib/static-1.26079",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.54056",
  "tinymce-copilot": "/tinymce-copilot/static-1.17344",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8375",
  "automation-ui-routing": "/automation-ui-routing/static-1.22131",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5966",
  "attribution-lib": "/attribution-lib/static-1.42909",
  "voice-agents-components": "/voice-agents-components/static-1.3961",
  "forms-ai-lib": "/forms-ai-lib/static-1.4890",
  "codemirror-dlb": "/codemirror-dlb/static-1.59667",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6851",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.36842"
}
};
